import { render } from "./Dices.vue?vue&type=template&id=9894f65c&scoped=true&bindings={\"notActive\":\"props\",\"click\":\"options\"}"
import script from "./Dices.vue?vue&type=script&lang=js"
export * from "./Dices.vue?vue&type=script&lang=js"

import "./Dices.vue?vue&type=style&index=0&id=9894f65c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9894f65c"

export default script